import { render, staticRenderFns } from "./ShiftQuestionOptionsEditor.vue?vue&type=template&id=9c647884&scoped=true"
import script from "./ShiftQuestionOptionsEditor.vue?vue&type=script&lang=js"
export * from "./ShiftQuestionOptionsEditor.vue?vue&type=script&lang=js"
import style0 from "./ShiftQuestionOptionsEditor.vue?vue&type=style&index=0&id=9c647884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c647884",
  null
  
)

export default component.exports